import type { StackProps } from '@mui/material';
import { Stack, styled } from '@mui/material';

// ----------------------------------------------------------------------

export type SummaryBarProps = StackProps;

// ---------------------------------------------------------------------

const StyledSummaryBar = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: theme.dimensions.summaryBar.height,
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1.5),
  borderRadius: 0,
  border: 'none',
  borderTop: theme.shape.divider,
  backgroundColor: theme.palette.background.paper,
})) as typeof Stack;

// ----------------------------------------------------------------------

export const SummaryBar = (props: SummaryBarProps) => <StyledSummaryBar direction="row" spacing={4} {...props} />;
